import {
    createVariable,
    removeVariable,
    updateVariable,
    Variable,
} from '../../../services/api/departmentVariablesService';
import { VariableDefault, RefVariableDefault } from '../utils/variableTypes';
import { toName } from '../utils/variableUtils';
import { canSaveVariableRow } from './variableRowUtils';

export interface VariableRowDraft {
    value: string;
    refId?: string;
    label: string;
}

interface PersistVariableDraftArgs {
    def: VariableDefault;
    savedVariable?: Variable;
    draft: VariableRowDraft;
    isCustom?: boolean;
}

export async function persistVariableDraft({
    def,
    savedVariable,
    draft,
    isCustom,
}: PersistVariableDraftArgs): Promise<void> {
    const canSave = canSaveVariableRow({
        def,
        editValue: draft.value,
        editRefId: draft.refId,
        isCustom,
    });

    if (!canSave) {
        return;
    }

    const type = def.field === 'ref' ? 'ref' : 'fixed';
    const payload = {
        type: type as Variable['type'],
        label: isCustom ? draft.label.trim() || undefined : undefined,
        fixedValue: draft.refId ? undefined : draft.value || undefined,
        refTarget:
            def.field === 'ref'
                ? (def as RefVariableDefault).refTarget
                : undefined,
        refId: draft.refId || undefined,
    };

    const newName = isCustom ? toName(draft.label) : def.name;
    const renamed = isCustom && newName !== def.name && draft.label.trim() !== '';

    if (renamed && savedVariable) {
        await removeVariable(def.name);
        await createVariable({ ...payload, name: newName });
        return;
    }

    if (savedVariable) {
        await updateVariable(def.name, payload);
        return;
    }

    await createVariable({ ...payload, name: newName });
}
